import { AxiosRequestConfig } from 'axios';
import axios from './axios';
import { DesignCategory, UserUploads } from './designCategories.interface';

const getDesginCategories = (): Promise<DesignCategory[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const config: AxiosRequestConfig = {
				method: 'get',
				url: '/outer-design',
			};
			const resp = await axios(config);
			const designCategoriesData = resp.data;
			resolve(designCategoriesData.data);
		} catch (error: any) {
			reject(error);
		}
	});
};

const getUserUploadsCategory = (
	workspaceId: string,
	userId: string,
	type: string,
	opts?: { source?: string }
): Promise<UserUploads> => {
	return new Promise(async (resolve, reject) => {
		try {
			const params = new URLSearchParams();
			if (workspaceId) params.set('workspaceId', workspaceId);
			if (userId) params.set('userId', userId);
			if (type) params.set('type', type);
			if (opts?.source) params.set('source', opts.source);

			const config: AxiosRequestConfig = {
				method: 'get',
				url: `/myUploads?${params.toString()}`,
			};
			const resp = await axios(config);
			const designCategoriesData = resp.data;
			resolve(designCategoriesData.data);
		} catch (error: any) {
			reject(error);
		}
	});
};

export const design_categories_services = {
	getDesginCategories,
	getUserUploadsCategory,
};
